/**
 * Barlow e Barlow Condensed auto-hospedadas (OFL, em src/assets/fonts):
 * a fábrica pode estar sem internet e a folha não pode depender de CDN.
 */
import { createGlobalStyle } from "styled-components";

import barlow400 from "../../../assets/fonts/barlow/barlow-latin-400-normal.woff2";
import barlow500 from "../../../assets/fonts/barlow/barlow-latin-500-normal.woff2";
import barlow600 from "../../../assets/fonts/barlow/barlow-latin-600-normal.woff2";
import barlow700 from "../../../assets/fonts/barlow/barlow-latin-700-normal.woff2";
import condensada500 from "../../../assets/fonts/barlow/barlow-condensed-latin-500-normal.woff2";
import condensada600 from "../../../assets/fonts/barlow/barlow-condensed-latin-600-normal.woff2";
import condensada700 from "../../../assets/fonts/barlow/barlow-condensed-latin-700-normal.woff2";
import condensada800 from "../../../assets/fonts/barlow/barlow-condensed-latin-800-normal.woff2";

export const FONTE_CORPO = '"Barlow", "Segoe UI", Arial, sans-serif';
export const FONTE_TITULO = '"Barlow Condensed", "Arial Narrow", Arial, sans-serif';

const face = (familia, peso, arquivo) => `
  @font-face {
    font-family: "${familia}";
    font-style: normal;
    font-weight: ${peso};
    font-display: block;
    src: url(${arquivo}) format("woff2");
  }
`;

export const FontesDaFolha = createGlobalStyle`
  ${face("Barlow", 400, barlow400)}
  ${face("Barlow", 500, barlow500)}
  ${face("Barlow", 600, barlow600)}
  ${face("Barlow", 700, barlow700)}
  ${face("Barlow Condensed", 500, condensada500)}
  ${face("Barlow Condensed", 600, condensada600)}
  ${face("Barlow Condensed", 700, condensada700)}
  ${face("Barlow Condensed", 800, condensada800)}
`;

/** Espera as fontes da folha carregarem antes de imprimir ou capturar. */
export async function aguardarFontes() {
  if (!document.fonts) return;
  await Promise.all([
    document.fonts.load(`400 12px "Barlow"`),
    document.fonts.load(`700 12px "Barlow"`),
    document.fonts.load(`800 34px "Barlow Condensed"`),
    document.fonts.load(`700 11px "Barlow Condensed"`),
  ]).catch((erro) => {
    // Fonte que não carrega não pode impedir a impressão: a folha sai com a
    // fonte de reserva (Arial) e o aviso fica no console para diagnóstico.
    console.warn("Fontes da folha de apontamento não carregaram:", erro);
  });
  await document.fonts.ready;
}
